import { InjectionToken } from '@angular/core';

export interface AumicoAiAgentsConfig {
    apiGateway: string;
    wsGateway: string;
}

export const AUMICO_AI_AGENTS_CONFIG = new InjectionToken<AumicoAiAgentsConfig>('AumicoAiAgentsConfig');
